(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bp-catalog-request-form"] && !Shopify.designMode) return;
  try {
    const form = document.getElementById('bp-catalog-request-form');
  const successMessage = document.getElementById('bp-catalog-request-success');
  const errorSummary = document.getElementById('bp-catalog-request-error-summary');
  const errorList = document.getElementById('bp-catalog-request-error-list');
  const submitButton = form.querySelector('.bp-catalog-request-form__submit');
  const genericErrorMessage = form.dataset.genericError;
  const recaptchaSiteKey = form.dataset.recaptchaSiteKey;

  function getRecaptchaToken(action) {
    console.log(action)
    return new Promise((resolve, reject) => {
      if (typeof grecaptcha === 'undefined' || !grecaptcha.enterprise) {
        reject(new Error('reCAPTCHA is not available.'));
        return;
      }

      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(recaptchaSiteKey, { action });
          resolve(token);
        } catch (error) {
          reject(error);
        }
      });
    });
  }

  function fieldInputId(fieldName) {
    return `bp-catalog-request-${fieldName.replace(/_/g, '-')}`;
  }

  function clearFieldErrors() {
    form.querySelectorAll('.bp-catalog-request-form__field-error').forEach((el) => {
      el.hidden = true;
      el.textContent = '';
    });
    form.querySelectorAll('[aria-invalid="true"]').forEach((el) => {
      el.removeAttribute('aria-invalid');
    });
  }

  function showFieldErrors(errors) {
    errorList.innerHTML = '';

    Object.entries(errors).forEach(([fieldName, messages]) => {
      const message = messages[0];
      const inputId = fieldInputId(fieldName);
      const input = document.getElementById(inputId);
      const errorEl = document.getElementById(`${inputId}-error`);

      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      if (input) {
        input.setAttribute('aria-invalid', 'true');
      }

      const listItem = document.createElement('li');
      if (input) {
        const link = document.createElement('a');
        link.href = `#${inputId}`;
        link.textContent = message;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          input.focus();
        });
        listItem.appendChild(link);
      } else {
        listItem.textContent = message;
      }
      errorList.appendChild(listItem);
    });

    errorSummary.hidden = false;
    const heading = errorSummary.querySelector('h2');
    requestAnimationFrame(() => {
      heading.focus();
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function showGenericError(message) {
    errorList.innerHTML = '';
    const listItem = document.createElement('li');
    listItem.textContent = message;
    errorList.appendChild(listItem);

    errorSummary.hidden = false;
    const heading = errorSummary.querySelector('h2');
    requestAnimationFrame(() => {
      heading.focus();
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function showSuccess() {
    form.hidden = true;
    successMessage.hidden = false;
    const heading = successMessage.querySelector('h2');
    requestAnimationFrame(() => {
      heading.focus();
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    clearFieldErrors();
    errorSummary.hidden = true;
    submitButton.disabled = true;

    try {
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());

      try {
        data.recaptcha_token = await getRecaptchaToken('catalog_request');
      } catch (recaptchaError) {
        showGenericError(genericErrorMessage);
        return;
      }

      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        if (typeof Shopify !== 'undefined' && Shopify.analytics) {
          await Shopify.analytics.publish('burpee:catalog_requested', {
            referral_source: data.referral_source,
          });
        }

        showSuccess();
        return;
      }

      const result = await response.json().catch(() => null);

      if (result && result.errors) {
        showFieldErrors(result.errors);
      } else {
        showGenericError((result && result.message) || genericErrorMessage);
      }
    } catch (error) {
      showGenericError(genericErrorMessage);
    } finally {
      submitButton.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bp-farmers-landing"] && !Shopify.designMode) return;
  try {
    const OPERATION_TYPE_RADIO_IDS = {
                  commercial_grower: 'bp-farmers-commercial-grower',
                  home_gardener: 'bp-farmers-home-gardener',
                  'non-profit': 'bp-farmers-non-profit',
                };

                document.getElementById('bp-farmers-operation-type')?.addEventListener('change', (event) => {
                  const radio = document.getElementById(OPERATION_TYPE_RADIO_IDS[event.target.value]);
                  if (radio instanceof HTMLInputElement) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                });
  } catch(e) { console.error(e); }
})();

})();
